import styled from 'styled-components';

export const StyledDescription = styled.div`
  font-size: 20px;
  line-height: 1.4;
`;
